export const capitalizeFirstLetter = (value: string) => {
    if (!value) {
        return value;
    }

    return `${value.charAt(0).toUpperCase()}${value.slice(1)}`;
};
